import React, {Fragment} from 'react'
import Iframe from 'react-iframe'


const DrawingRegister = () => {
	const store = require('store')

	return (
		// console.log(process.env.REACT_APP_DR_URL),
		// console.log(store.get('access_token')),
		// console.log(store.get('site_code')),

		<Fragment>
			<Iframe
				url={process.env.REACT_APP_DR_URL + "?access_token=" + store.get('access_token') + "&site=" + store.get('site_code') + "&redirect_url=drawreg"}
				// url={"http://218.255.151.244/WorkflowSystem/tokenLogin?access_token=5ad2720e-c6c8-4dbf-9b0c-0ceb96331a74&site=KTIL240&redirect_url=drawreg"}
				// url={"https://portal.sanfield.com.hk/login.jsp"}
				id="DrawingRegister"
				width="100%"
				height={window.outerHeight - (window.outerHeight - window.innerHeight + 100)}
				display="initial"
				position="relative"
				frameBorder="0"
				overflow="auto"
				sandbox="allow-same-origin allow-scripts allow-popups allow-downloads"

				// className="myClassname"
			/>
		</Fragment>
	)
}

export default DrawingRegister